import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Noti = (type: any, content: any, duration: any) => {
    switch (type) {
        case 'success':
            toast.success(`${content || 'Unknown'}`, {
                position: "top-right",
                autoClose: duration || 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                style: {
                    background: '#000',
                    fontFamily: "Noto Sans",
                    color: '#fff',
                    borderRadius: '12px',
                    overflow: "hidden",
                    fontWeight: 500,
                    fontSize: '16px',
                    padding: '16px 20px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                },
            })
            break;
        case 'info':
            toast.info(`${content || 'Unknown'}`, {
                position: "top-right",
                autoClose: duration || 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                style: {
                    background: '#000',
                    fontFamily: "Noto Sans",
                    color: '#fff',
                    borderRadius: '12px',
                    overflow: "hidden",
                    fontWeight: 500,
                    fontSize: '16px',
                    padding: '16px 20px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                },
            })
            break;
        case 'warn':
            toast.warn(`${content || 'Unknown'}`, {
                position: "top-right",
                autoClose: duration || 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                style: {
                    background: '#000',
                    fontFamily: "Noto Sans",
                    color: '#fff',
                    borderRadius: '12px',
                    overflow: "hidden",
                    fontWeight: 500,
                    fontSize: '16px',
                    padding: '16px 20px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                },
            })
            break;
        case 'error':
            toast.error(`${content || 'Unknown'} `, {
                position: "top-right",
                autoClose: duration || 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                style: {
                    background: '#000',
                    fontFamily: "Noto Sans",
                    color: '#fff',
                    borderRadius: '12px',
                    overflow: "hidden",
                    fontWeight: 500,
                    fontSize: '16px',
                    padding: '16px 20px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                },
            })
            break;

        default:
            toast.error(`${content || 'Unknown'}`, {
                position: "top-right",
                autoClose: duration || 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                style: {
                    background: '#000',
                    fontFamily: "Noto Sans",
                    color: '#fff',
                    borderRadius: '12px',
                    overflow: "hidden",
                    fontWeight: 500,
                    fontSize: '16px',
                    padding: '16px 20px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                },
            })
            break;
    }

}